module.exports = __webpack_public_path__ + "media/img/payments/dashboard-1303f34311ccf6d9955ea38c1ee5844e.png";